export function lkMenu() {
    let lkMenu = document.querySelector('[data-lkMenu]');
    let lkMenuBtn = document.querySelector('[data-lkMenuBtn]');
    let lkContent = document.querySelector('[data-lkContent]');

    if (lkMenu) {

        function openMenu() {
            lkContent.classList.add('_hidden');
            lkMenu.classList.add('_open');
        }

        lkMenuBtn.addEventListener('click', openMenu);
    }
}
